import PropTypes from 'prop-types';
import {useCallback, useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import {updateDeliveryAddressField, updateDeliveryContactNumber} from '../../v2/actions/address-actions';
import addressDefinitionsByCountry from '../../v2/components/address/address-definitions-by-country';
import AddressFields from '../../v2/components/address/AddressFields';

import ContactNumber from '../../v2/components/address/ContactNumber/ContactNumber';
import FieldContainer2 from '../../v2/form/FieldContainer2';
import getIsUsingExpressCheckout from '../../v2/selectors/ExpressSelectors/getIsUsingExpressCheckout';
import {getSelectedDeliveryCountry} from '../../v2/selectors/selectors';
import V2Components from '../../v2/v2-components';

const prefixErrors = errors => errors?.map(error => ({
  fieldName: `contactSection.${error.fieldName}`,
  errorCode: error.errorCode,
}));

export function ContactSectionPresentational(props) {
  const fieldContainerRef = useRef(null);
  
  const validate = useCallback(
    () => {
      if (!fieldContainerRef.current) return {isValid: true};
      const containerValidationResult = fieldContainerRef.current.validate();
      return {
        isValid: containerValidationResult.isValid,
        errors: prefixErrors(containerValidationResult.errors),
      };
    }, [fieldContainerRef],
  );
  
  useEffect(() => {
    V2Components.register('ContactSection', {validate});
    return () => V2Components.clear('ContactSection');
  }, [validate]);
  
  const fieldsToShow = addressDefinitionsByCountry.get(props.deliveryCountry)
    .filter(field => field.name === 'addressee');
  
  return (
    <div data-test="ContactSectionForm">
      <FieldContainer2 fieldUpdateDispatcher={props.updateAddressField}>
        {(fieldContainer) => {
          fieldContainerRef.current = fieldContainer;
          return (
            <>
              <AddressFields
                definedFields={fieldsToShow}
                addressType="contact"
                fieldContainer={fieldContainer}
                fieldNamePrefix="contactInfo"
                fieldValues={props.addressValues}
                shouldRenderAddressLookUp={false}
              />
              {!props.usingExpressCheckout && (
                <ContactNumber
                  fieldContainer={fieldContainer.fieldUpdateDispatcher(props.updateContactNumberDispatcher)} />
              )}
            </>
          );
        }}
      </FieldContainer2>
    </div>
  );
}

ContactSectionPresentational.propTypes = {
  definedField: PropTypes.object.isRequired,
  addressValues: PropTypes.object.isRequired,
  deliveryCountry: PropTypes.string.isRequired,
  usingExpressCheckout: PropTypes.bool.isRequired,
  updateAddressField: PropTypes.func.isRequired,
  updateContactNumberDispatcher: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deliveryCountry: getSelectedDeliveryCountry(state),
  addressValues: state.address.deliveryAddressList.addresses[''],
  usingExpressCheckout: getIsUsingExpressCheckout(state),
});

function mapDispatchToProps(dispatch) {
  return {
    updateAddressField: (fieldName, value) => {
      dispatch(updateDeliveryAddressField({addressId: ''}, fieldName, value));
    },
    updateContactNumberDispatcher: (_, value) => {
      dispatch(updateDeliveryContactNumber(value));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactSectionPresentational);
